/**
 *
 * @param node
 * @returns {EventProcessor}
 */
EventProcessor.create = function (node) {
    var eventProcessor = new EventProcessor();

    eventProcessor.__node = node;
    eventProcessor.label = Utils.getNextDefaultLabel(node.eventProcessors, "Event Processor", 1);
    eventProcessor.id = Utils.getNextDefaultId(node.eventProcessors, "EventProcessor", 1);
    eventProcessor.observables = [];
    eventProcessor.trigger = {type: "singleStateChange", content: {}};
    eventProcessor.action = {type: "nodeService", content: {}};

    return eventProcessor;
};

/**
 *
 * @param node
 * @param EventProcessor
 * @returns {*}
 */
EventProcessor.bind = function (node, eventProcessor) {
    Utils.inheritMethods(eventProcessor, new EventProcessor());

    eventProcessor.bind(node);

    return eventProcessor;
};

/**
 *
 */
function EventProcessor() {
    /**
     *
     */
    EventProcessor.prototype.bind = function (node) {
        this.__node = node;
    };
}
